import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useMenu = () => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['menu'],
    queryFn: async () => {
      const result = await restClient({ url: `${prefix}/slide-menu`});
      return result;
    },
    // Cache del menu per tutta la sessione (il menu non cambia frequentemente)
    staleTime: Infinity, 
    cacheTime: Infinity  
  });
};
